export default __webpack_public_path__ + "static/media/sd-invisible-symbol.3dca0f0e.svg";